import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=7c1e3ffc&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"
import style0 from "./remark.vue?vue&type=style&index=0&id=7c1e3ffc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1e3ffc",
  null
  
)

export default component.exports